// src/components/Categories/CollectionsStrip.js
import React, { useRef } from "react";
import { collectionBanners } from "../../data/products";
import "./CollectionsStrip.css";

export default function CollectionsStrip() {
  const scrollRef = useRef(null);

  const scroll = (dir) => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({ left: dir * 220, behavior: "smooth" });
    }
  };

  return (
    <div className="collections-strip">
      <div className="container">
        <div className="collections-strip__header">
          <h2 className="collections-strip__title">SHOP BY COLLECTION</h2>
          <div className="collections-strip__arrows">
            <button className="collections-strip__arrow" onClick={() => scroll(-1)}>
              <svg width="10" height="16" viewBox="0 0 10 18" fill="none">
                <path d="M9 1L1 9L9 17" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"/>
              </svg>
            </button>
            <button className="collections-strip__arrow" onClick={() => scroll(1)}>
              <svg width="10" height="16" viewBox="0 0 10 18" fill="none">
                <path d="M1 1L9 9L1 17" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"/>
              </svg>
            </button>
          </div>
        </div>
        <div className="collections-strip__scroll" ref={scrollRef}>
          {collectionBanners.map(col => (
            <div key={col.id} className="collection-item">
              <div className="collection-item__img-wrap">
                <img src={col.img} alt={col.label} className="collection-item__img" loading="lazy" />
              </div>
              <p className="collection-item__label">{col.label}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
